import ApplicationSerializer from 'cio/serializers/application';
import DS, { ModelSchema } from 'ember-data';
import { ModelRegistry } from 'ember-data/model';

const { EmbeddedRecordsMixin } = DS;

export default class AssetSerializer extends ApplicationSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    createdAt: { serialize: false },
    createdBy: {
      serialize: false,
      deserialize: 'records',
    },
    updatedAt: { serialize: false },
    updatedBy: {
      serialize: false,
      deserialize: 'records',
    },
    inUse: { serialize: false },
  },
}) {
  normalizeResponse(
    store: DS.Store,
    type: ModelSchema<keyof ModelRegistry>,
    payload: Record<string, any>,
    id: string,
    requestType: string,
  ) {
    // Load parent assets into the store. We don't want to mix them with the assets
    // in the response so we don't have to filter them out when listing assets.
    if (payload.parents != null) {
      store.pushPayload({ assets: [...payload.parents] });
    }

    return super.normalizeResponse(store, type, payload, id, requestType);
  }
}
